var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "text-center" },
        [
          _c("h2", { staticClass: "mb-5" }, [_c("b", [_vm._v("ETIQUETAS")])]),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "align-items-center justify-content-center" },
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "12" } },
                [
                  _c("b-select", {
                    staticClass: "text-center escolha_col_etiqueta",
                    attrs: { options: _vm.etiquetas },
                    model: {
                      value: _vm.escolha,
                      callback: function($$v) {
                        _vm.escolha = $$v
                      },
                      expression: "escolha"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "my-2", attrs: { cols: "12" } },
                [_c("etiquetas", { attrs: { escolha: _vm.escolha } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mt-2", attrs: { cols: "12" } },
                [
                  _c("b-textarea", {
                    staticClass: "mb-2",
                    attrs: { rows: "9" },
                    model: {
                      value: _vm.produtos,
                      callback: function($$v) {
                        _vm.produtos = $$v
                      },
                      expression: "produtos"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.Baixar()
                        }
                      }
                    },
                    [_vm._v("Gerar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0027ac98", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0027ac98","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/EtiquetaIndex.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0027ac98","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/distribuidor/EtiquetaIndex.vue
// module chunks = 2